export default __webpack_public_path__ + "static/media/archive.768ef807.svg";